export const BUILDING_FORM_NOTES_FIELD_MIN_ROWS = 4
